/**
 * Dognet S2S click attribution → SuperApp → cart.attributes.dognet_visitor_id
 * Sale běží server-side ve SuperApp (webhook), ne přes PostAffTracker.
 */
(function () {
  var SUPERAPP_BASE = 'https://superapp.kolorky-cml.cz';
  var ATTR_VISITOR = 'dognet_visitor_id';
  var ATTR_CAMPAIGN = 'dognet_campaign_id';

  function shopDomain() {
    if (window.Shopify && Shopify.shop) return Shopify.shop;
    return window.location.hostname;
  }

  function qs(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function setCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      if (!res.ok) throw new Error('Dognet: cart/update.js HTTP ' + res.status);
      return res.json();
    });
  }

  function fetchStorefrontConfig() {
    var url = SUPERAPP_BASE + '/shopify/dognet/storefront_config?shop=' + encodeURIComponent(shopDomain());
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && data.error) || ('Dognet storefront_config HTTP ' + res.status));
        return data;
      });
    });
  }

  // Shopify Customer Privacy API (stejná jako v popup.liquid / theme.js consent-tracking-api).
  function trackingAllowed() {
    return new Promise(function (resolve, reject) {
      function check() {
        if (!window.Shopify || !Shopify.customerPrivacy) {
          reject(new Error('Dognet: require_cookie_consent je zapnuto, ale Shopify.customerPrivacy není dostupné'));
          return;
        }
        resolve(Shopify.customerPrivacy.userCanBeTracked());
      }

      if (window.Shopify && Shopify.customerPrivacy) return check();
      if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') return check();

      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) reject(error);
        else check();
      });
    });
  }

  function runClick() {
    var aAid = qs('a_aid');
    var visitorId = qs('visitorId') || qs('visitor_id');
    if (!aAid && !visitorId) return;

    fetchStorefrontConfig()
      .then(function (config) {
        if (!config.enabled || !config.script_enabled) return null;
        if (!config.require_cookie_consent) return config;
        return trackingAllowed().then(function (allowed) {
          return allowed ? config : null;
        });
      })
      .then(function (config) {
        if (config) sendClick(aAid, visitorId);
      })
      .catch(function (err) {
        console.error('[Dognet S2S]', err);
      });
  }

  function sendClick(aAid, visitorId) {
    var marketHandle = null;
    try {
      marketHandle = (window.Shopify && Shopify.country) || null;
    } catch (e) {}

    var body = new URLSearchParams();
    body.set('shop', shopDomain());
    if (aAid) body.set('a_aid', aAid);
    if (visitorId) body.set('visitor_id', visitorId);
    body.set('hostname', window.location.hostname);
    body.set('url', window.location.href);
    body.set('referrer', document.referrer || '');
    if (marketHandle) body.set('market_handle', String(marketHandle).toLowerCase());

    fetch(SUPERAPP_BASE + '/shopify/dognet/click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: body.toString()
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && data.error) || ('Dognet click HTTP ' + res.status));
          return data;
        });
      })
      .then(function (data) {
        if (!data.visitor_id) throw new Error('Dognet click: chybí visitor_id v odpovědi');
        var attrs = {};
        attrs[ATTR_VISITOR] = data.visitor_id;
        if (data.campaign_id) attrs[ATTR_CAMPAIGN] = data.campaign_id;
        if (marketHandle) attrs.dognet_market = String(marketHandle).toLowerCase();
        return setCartAttributes(attrs);
      })
      .catch(function (err) {
        console.error('[Dognet S2S]', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runClick);
  } else {
    runClick();
  }
})();
